export default __webpack_public_path__ + "static/media/sassi_3.2502eae3.png";